import { NgClass } from '@angular/common';
import {
  AfterViewInit,
  Component,
  inject,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { UsersNewsletterRegistered } from '@core/interfaces/usersNewsletterRegistered';
import { EmailService } from '@core/services/email.service';
import { UsersNewsletterRegisteredService } from '@core/services/usersNewsletterRegistered.service';
import { FormUtils } from '@core/utils/form-utils';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslatePipe } from '@ngx-translate/core';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-newsletter-dialog',
    templateUrl: './newsletter-dialog.component.html',
    styleUrls: ['./newsletter-dialog.component.scss'],
    imports: [NgClass, FormsModule, TranslatePipe]
})
@UntilDestroy()
export class NewsletterDialogComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  @Input() email: string;
  @Input() isMemorabid: boolean = true;

  private subscription: Subscription;
  isEmailInvalid = false;

  activeModal = inject(NgbActiveModal);
  private router = inject(Router);
  private emailService = inject(EmailService);

  private recaptchaV3Service = inject(ReCaptchaV3Service);
  private usersNewsletterRegistered = inject(UsersNewsletterRegisteredService);

  constructor() {}

  ngOnInit(): void {
    if (FormUtils.emailRegex.test(this.email)) {
      this.isEmailInvalid = false;
    } else {
      this.isEmailInvalid = true;
    }
  }

  ngAfterViewInit() {
    this.emailService.showReCaptchaBadge();
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.emailService.hideReCaptchaBadge();
  }

  subscribe(contactForm: NgForm) {
    const email: UsersNewsletterRegistered = {
      idRegistration: -1,
      userEmail: this.email,
    };

    if (contactForm.invalid) {
      for (const control of Object.keys(contactForm.controls)) {
        contactForm.controls[control].markAsTouched();
      }
      return;
    }

    this.subscription = this.recaptchaV3Service
      .execute('newsletterForm')
      .subscribe((token: string) => {
        this.emailService
          .verifyReCaptcha({ responseToken: token })
          .pipe(untilDestroyed(this))
          .subscribe(() => {
            this.usersNewsletterRegistered
              .insert(email)
              .pipe(untilDestroyed(this))
              .subscribe(() => {
                this.activeModal.close();
              });
          });
      });
  }

  goToPage(route: string) {
    this.activeModal.close();
    this.router.navigate([route]);
  }
}
